import * as THREE from "three";
import loadingManager from "./loader.js";

export default function materials(scene){
    const textureLoader = new THREE.TextureLoader(loadingManager)

    const ColorTextureWoodLight = textureLoader.load('./textures/mid-wood/WalnutAlbedo.jpg')
    const NormalTextureWoodLight = textureLoader.load('./textures/mid-wood/WalnutNormalMap.png')
    const ARMTextureWoodLight = textureLoader.load('./textures/mid-wood/WalnutRoughness.png')

    ColorTextureWoodLight.colorSpace = THREE.SRGBColorSpace
    ColorTextureWoodLight.wrapT = THREE.RepeatWrapping
    ColorTextureWoodLight.wrapS = THREE.RepeatWrapping

    NormalTextureWoodLight.wrapT = THREE.RepeatWrapping
    NormalTextureWoodLight.wrapS = THREE.RepeatWrapping

    ARMTextureWoodLight.wrapT = THREE.RepeatWrapping
    ARMTextureWoodLight.wrapS = THREE.RepeatWrapping


    const materialWoodLight =     new THREE.MeshStandardMaterial({
        map: ColorTextureWoodLight,
        roughnessMap: ARMTextureWoodLight,
        // normalMap: NormalTextureWoodLight,
    })

    // ColorTextureWoodLight.center.set(0.5, 0.5)
    //
    // ColorTextureWoodLight.rotation = Math.PI / 2



    const ColorTextureWoodMedium = textureLoader.load('./textures/dark-wood/Wooden_Planks_vjisagn_1K_BaseColor.jpg')
    const NormalTextureWoodMedium = textureLoader.load('./textures/dark-wood/Wooden_Planks_vjisagn_1K_Normal.jpg')
    const ARMTextureWoodMedium = textureLoader.load('./textures/dark-wood/Wooden_Planks_vjisagn_1K_Roughness.jpg')

    ColorTextureWoodMedium.colorSpace = THREE.SRGBColorSpace
    ColorTextureWoodMedium.wrapT = THREE.RepeatWrapping
    ColorTextureWoodMedium.wrapS = THREE.RepeatWrapping

    NormalTextureWoodMedium.wrapT = THREE.RepeatWrapping
    NormalTextureWoodMedium.wrapS = THREE.RepeatWrapping

    ARMTextureWoodMedium.wrapT = THREE.RepeatWrapping
    ARMTextureWoodMedium.wrapS = THREE.RepeatWrapping

    const materialWoodMedium =     new THREE.MeshStandardMaterial({
        map: ColorTextureWoodMedium,
        roughnessMap: ARMTextureWoodMedium,
        // normalMap: NormalTextureWoodMedium,
    })

    // ColorTextureWoodMedium.center.set(0.5, 0.5)
    //
    // ColorTextureWoodMedium.rotation = Math.PI / 2

    return { materialWoodLight, materialWoodMedium}
}